const Joi = require("joi");

// Schemas
const loginSchema = Joi.object({
  email: Joi.string().required(),
  password: Joi.string().required(),
});

export { loginSchema };
